import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AddressFormGroup } from '@core/components/address-block/address-block.component';
import { APIAdminClient } from '@core/typings/api/admin-client.typing';
import { ProcessingTypes } from '@core/typings/payment.typing';
import { AllowedLocation } from '@core/typings/program.typing';
import { AddOrgUI } from '@core/typings/ui/add-org.typing';
import { AddOrganizationService } from '@features/add-organization/add-organization.service';
import { ClientSettingsService } from '@features/client-settings/client-settings.service';
import { TypeSafeFormGroup } from '@yourcause/common/core-forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'gc-add-org-address',
  templateUrl: './add-org-address.component.html',
  styleUrls: ['./add-org-address.component.scss']
})
export class AddOrgAddressComponent implements OnInit, OnDestroy {
  @Input() addressFormGroup: TypeSafeFormGroup<AddressFormGroup>;
  @Input() processorType: ProcessingTypes;
  @Input() allowedOrgLocations: AllowedLocation[];

  private sub = new Subscription();
  hasInternational = this.clientSettingsService.doesClientHaveClientFeature(APIAdminClient.ClientFeatureTypes.HasInternational);
  
  constructor (
    private clientSettingsService: ClientSettingsService,
    private addOrgService: AddOrganizationService
  ) { }

  get clientCountry () {
    return this.clientSettingsService.clientSettings.country;
  }

  ngOnInit () {
    this.addressFormGroup.get('countryCode').setValue(this.addOrgService.addOrgPayload.country);
    this.addOrgService.setValidation(this.addressFormGroup.valid);
    this.sub.add(this.addressFormGroup.statusChanges.subscribe(() => {
      this.addOrgService.setValidation(this.addressFormGroup.valid);
    }));
    this.sub.add(this.addressFormGroup.valueChanges.subscribe(() => {
      this.updateAddOrg('address', this.addressFormGroup.value);
    }));
  }

  updateAddOrg <K extends keyof AddOrgUI.AddOrgPayload> (
    attr: K,
    data: AddOrgUI.AddOrgPayload[K]
  ) {
    this.addOrgService.setAddOrgAttr(attr, data);
  }


  ngOnDestroy () {
    this.sub.unsubscribe();
  }
}
